import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

@Component({
  selector: 'app-development-budget-expenditure',
  templateUrl: './development-budget-expenditure.component.html',
  styleUrls: ['./development-budget-expenditure.component.scss']
})
export class DevelopmentBudgetExpenditureComponent implements OnInit {

  expenditureForm!: FormGroup;
  financialYear: string | null = null;
  blockId: number | null = null;
  tribalAreas: any[] = [];
  reportData: any;
  UserDetails: any;
  tribalData: any[] = [];
  isViewMode: boolean = false;


  constructor(private fb: FormBuilder,
    private reportService: ReportsService,
    private toastService: ToastService, private cd: ChangeDetectorRef,
    private router: Router,
    private authService: AuthService,
    private ActivatedRoute: ActivatedRoute) { }

  ngOnInit(): void {

    this.expenditureForm = this.fb.group({
      blockId: [null],
      financialYear: [''],
      dataMonth: [null],
      type: [1, Validators.required],
      tribalArea: [''],
      t41Budget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      t41Amount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      t42Budget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      t42Amount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      t44Budget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      t44Amount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      tOverALLBudget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      tOverALLAmount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cpsoUndertaking43Budget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cpsoUndertaking43Amount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cipacCoop43Budget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cipacCoop43Amount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      csciCoop43Budget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      csciCoop43Amount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cNewSCMemberBudget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cNewSCMemberAmount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cscCoopBudget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cscCoopAmount: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cOverAllBudget: [0, [Validators.required, Validators.pattern(/^\d+$/)]],
      cOverAllAmount: [0, [Validators.required, Validators.pattern(/^\d+$/)]]
    });



    //   this.ActivatedRoute.queryParams.subscribe(params => {
    //   if (params['data']) {
    //     this.reportData = JSON.parse(params['data']);
    //     this.editRow(this.reportData);
    //   }
    // });

    this.ActivatedRoute.queryParams.subscribe(params => {
      this.reportData = params['data'] ? JSON.parse(params['data']) : null;
      this.isViewMode = params['viewMode'] === 'true'; // ✅ check flag
      if (this.reportData)
        this.editRow(this.reportData);
      // this.editRow(this.reportData);
      // if (data) {
      //   this.expenditureForm.patchValue(data);
      // }

      this.ActivatedRoute.queryParams.subscribe(params => {
        this.financialYear = params['financialYear']
          ? params['financialYear']
          : this.reportData?.financialYear ?? null;

        this.blockId = params['blockOffice']
          ? Number(params['blockOffice'])
          : Number(this.reportData?.blockID ?? 0);


      });

      if (this.isViewMode) {
        this.expenditureForm.disable(); // ✅ disable entire form
      }
    });

    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;
    this.getTribal();


    // 👇 When type changes, toggle validators
    this.expenditureForm.get('type')?.valueChanges.subscribe((val: any) => {
      if (val == 1) {
        // Remove validation from C-group
        this.toggleValidators([
          'cpsoUndertaking43Budget', 'cpsoUndertaking43Amount',
          'cipacCoop43Budget', 'cipacCoop43Amount',
          'csciCoop43Budget', 'csciCoop43Amount',
          'cNewSCMemberBudget', 'cNewSCMemberAmount',
          'cscCoopBudget', 'cscCoopAmount',
          'cOverAllBudget', 'cOverAllAmount',
          'tribalArea'
        ], false);

        // Apply validation to T-group
        this.toggleValidators([
          't41Budget', 't41Amount',
          't42Budget', 't42Amount',
          't44Budget', 't44Amount',
          'tOverALLBudget', 'tOverALLAmount'
        ], true);
      } else if (val == 2) {
        // Remove validation from T-group
        this.toggleValidators([
          't41Budget', 't41Amount',
          't42Budget', 't42Amount',
          't44Budget', 't44Amount',
          'tOverALLBudget', 'tOverALLAmount'
        ], false);

        // Apply validation to C-group
        this.toggleValidators([
          'cpsoUndertaking43Budget', 'cpsoUndertaking43Amount',
          'cipacCoop43Budget', 'cipacCoop43Amount',
          'csciCoop43Budget', 'csciCoop43Amount',
          'cNewSCMemberBudget', 'cNewSCMemberAmount',
          'cscCoopBudget', 'cscCoopAmount',
          'cOverAllBudget', 'cOverAllAmount',
          'tribalArea'
        ], true);
      }
      this.expenditureForm.markAsUntouched()
    });




  }

  // ✅ Helper function to enable/disable validators dynamically
  toggleValidators(fields: string[], enable: boolean) {
    fields.forEach(field => {
      const control = this.expenditureForm.get(field);
      if (!control) return;

      if (enable) {
        control.setValidators([Validators.required, Validators.pattern(/^\d+$/)]);
      } else {
        control.clearValidators();
        // control.setValue(''); // optional: reset value
      }

      control.updateValueAndValidity();
    });
  }

  onSubmit(): void {
    // this.isSubmitted = true;

    if (this.expenditureForm.invalid) {
      this.expenditureForm.markAllAsTouched();
      return;
    }

    const formData = this.expenditureForm.getRawValue();
    const finalObj = {
      id: this.edit ? this.editId : 0,
      blockId: this.edit ? formData.blockId : this.blockId,
      financialYear: this.edit ? formData.financialYear : this.financialYear,
      // dataMonth:formData.dataMonth != null || 0 ?formData.dataMonth: new Date().toISOString(),
      dataMonth: formData.dataMonth ? formData.dataMonth : new Date().getMonth() + 1,

      type: formData.type,
      tribalArea: formData.tribalArea,
      t41Budget: Number(formData.t41Budget) || 0,
      t41Amount: Number(formData.t41Amount) || 0,
      t42Budget: Number(formData.t42Budget) || 0,
      t42Amount: Number(formData.t42Amount) || 0,
      t44Budget: Number(formData.t44Budget) || 0,
      t44Amount: Number(formData.t44Amount) || 0,
      tOverALLBudget: Number(formData.tOverALLBudget) || 0,
      tOverALLAmount: Number(formData.tOverALLAmount) || 0,
      cpsoUndertaking43Budget: Number(formData.cpsoUndertaking43Budget) || 0,
      cpsoUndertaking43Amount: Number(formData.cpsoUndertaking43Amount) || 0,
      cipacCoop43Budget: Number(formData.cipacCoop43Budget) || 0,
      cipacCoop43Amount: Number(formData.cipacCoop43Amount) || 0,
      csciCoop43Budget: Number(formData.csciCoop43Budget) || 0,
      csciCoop43Amount: Number(formData.csciCoop43Amount) || 0,
      cNewSCMemberBudget: Number(formData.cNewSCMemberBudget) || 0,
      cNewSCMemberAmount: Number(formData.cNewSCMemberAmount) || 0,
      cscCoopBudget: Number(formData.cscCoopBudget) || 0,
      cscCoopAmount: Number(formData.cscCoopAmount) || 0,
      cOverAllBudget: Number(formData.cOverAllBudget) || 0,
      cOverAllAmount: Number(formData.cOverAllAmount) || 0
    };


    this.reportService.addDevelopmentExpenditure(finalObj).subscribe({
      next: (res) => {
        if (res?.status === 200) {
          this.toastService.showSuccess(res.message);
          // this.router.navigate(['/reports/developmentBudgetExpenditureReport']);
          this.goToReportPage();
          // this.hideModal('addAuditDataModal');
          // this.getAuditData();
          this.edit = false;
          this.expenditureForm.reset();
          // this.isSubmitted = false;
        }
      },
      error: () => {
        this.toastService.showError('Something went wrong while saving.');
      }
    });
  }

  edit = false;
  editId = 0

  editRow(row: any): void {
    this.expenditureForm.patchValue({
      blockId: row.blockID,
      financialYear: row.financialYear,
      dataMonth: row.dataMonth,
      type: row.type,
      tribalArea: row.tribalArea,
      t41Budget: row.t41Budget,
      t41Amount: row.t41Amount,
      t42Budget: row.t42Budget,
      t42Amount: row.t42Amount,
      t44Budget: row.t44Budget,
      t44Amount: row.t44Amount,
      tOverALLBudget: row.tOverALLBudget,
      tOverALLAmount: row.tOverALLAmount,
      cpsoUndertaking43Budget: row.cpsoUndertaking43Budget,
      cpsoUndertaking43Amount: row.cpsoUndertaking43Amount,
      cipacCoop43Budget: row.cipacCoop43Budget,
      cipacCoop43Amount: row.cipacCoop43Amount,
      csciCoop43Budget: row.csciCoop43Budget,
      csciCoop43Amount: row.csciCoop43Amount,
      cNewSCMemberBudget: row.cNewSCMemberBudget,
      cNewSCMemberAmount: row.cNewSCMemberAmount,
      cscCoopBudget: row.cscCoopBudget,
      cscCoopAmount: row.cscCoopAmount,
      cOverAllBudget: row.cOverAllBudget,
      cOverAllAmount: row.cOverAllAmount
    });

    this.editId = row.id;
    this.edit = true;
    if (row.type == 1) {
      this.showTribal = false;
    }
    if (row.type == 2) {
      this.showCircle = false;
    }

    // this.openModal('addAuditDataModal');
  }

  getTribal() {
    let obj = {
      "circleId": this.UserDetails?.iCircleId
    }

    this.reportService.getTribalDdata(obj).subscribe((res: any) => {
      if (res) {
        this.tribalData = res.data.tribal;
        //this.targetForm.controls['blockOffice'].setValue('');

      }
    },
      (error: any) => {
      }
    );
  }
  showCircle = true;
  showTribal = true;




  goToReportPage() {
    this.router.navigate(
      ['/reports/developmentBudgetExpenditureReport'],
      {
        queryParams: {
          financialYear: this.financialYear,
          blockOffice: this.blockId
        }
      }
    );
  }


  onlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow only digits (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }



}
